<template><div><h1>url querystring</h1>
<pre class="hljs"><code><span class="hljs-keyword">import</span> { querystring } <span class="hljs-keyword">from</span> <span class="hljs-string">'vux'</span>

querystring.parse(<span class="hljs-string">'a=b&amp;c=d'</span>) <span class="hljs-comment">// {a:'b',c:'d'}, 默认参数为 location.search</span>

querystring.stringify({<span class="hljs-attr">a</span>:<span class="hljs-string">'b'</span>,<span class="hljs-attr">c</span>:<span class="hljs-string">'d'</span>}) <span class="hljs-comment">// 'a=b&amp;c=d'，注意不支持复杂嵌套的结构</span>
</code></pre>
</div></template><script>
export default {
  head: {"title":"Vue querystring url | VUX - Vue 移动端 UI 组件库","ignoreSuffixChar":"|"}
}
  </script>


// WEBPACK FOOTER //
// querystring-182.vue?e9b42de2